export default __webpack_public_path__ + "static/media/01__o_0.b21551b8.jpg";